import { getCookie } from 'cookies-next'
import { useCallback } from 'react'
import { useMutation } from '@apollo/client/react'
import { getNetworkStatusCode } from 'lib/helpers/getNetworkStatusCode/getNetworkStatusCode'
import { deleteTokenCookie } from 'lib/helpers/deleteTokenCookie/deleteTokenCookie'
import { cookieKeys } from 'lib/consts/browserStorage'
import { logError } from '../../tracking/datadog'
import { forgetSocureSession } from '../../tracking/socure/socure'
import { DeleteTokenCookieHook_signOutDocument } from './useDeleteTokenCookie.graphql'

export const useDeleteTokenCookie = () => {
  const [signOut] = useMutation(DeleteTokenCookieHook_signOutDocument)

  return useCallback(async () => {
    const token = getCookie(cookieKeys.token)

    if (!token) {
      return
    }

    try {
      await signOut()
    } catch (err) {
      if (getNetworkStatusCode(err) !== 401) {
        logError(err, { message: 'Failed to sign out' })
      }
    }

    deleteTokenCookie()

    // End the Socure session too — the render path can't observe this deletion (see forgetSocureSession).
    void forgetSocureSession()
  }, [signOut])
}
